export default __webpack_public_path__ + "static/media/2_stipe.c2fb2c79.svg";